import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { TcDumbComponent } from '@tc/abstract';

/**
 * Renders an email link
 */
@Component({
  selector: 'tc-grid-email-renderer',
  templateUrl: './tc-grid-email-renderer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class TcGridEmailRendererComponent
  extends TcDumbComponent
  implements AgRendererComponent
{
  /**
   * Value of the cell
   */
  public cellValue: string;

  agInit(params: ICellRendererParams) {
    this.cellValue = params.value;
  }

  refresh(params: ICellRendererParams) {
    return false;
  }
}
